import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=02c6d922&scoped=true"
import script from "./CustomerService.vue?vue&type=script&lang=js"
export * from "./CustomerService.vue?vue&type=script&lang=js"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=02c6d922&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c6d922",
  null
  
)

export default component.exports